import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import Modal from 'react-responsive-modal'

import ColourActions from '../../Redux/ColourRedux'
import SizeActions from '../../Redux/SizeRedux'
import CreateSize from '../../Containers/Ecommerce/CreateSize'
import CreateColour from '../../Containers/Ecommerce/CreateColour'
import UpdateSize from '../../Containers/Ecommerce/UpdateSize'
import UpdateColour from '../../Containers/Ecommerce/UpdateColour'

class ManageVariant extends React.Component {
  constructor (props) {
    super(props)
    this.dateformat = 'Y-MM-DD'
    this.state = {
      tab: 'tab-colour',
      page: 1,
      showModal: null,
      detail: {}
    }
  }

  componentDidMount = () => {
    this._fetchVariant(this.state.tab, this.state.page)
  }

  _fetchVariant = (tab, params) => {
    switch (tab) {
      case 'tab-colour':
        return this.props.getColour(params)
      case 'tab-size':
        return this.props.getSize(params)
      default:
        return null
    }
  }

  _changeTab = (tab) => {
    this.setState({ tab, page: 1 })
    setTimeout(() => {
      const params = { page: this.state.page }
      this._fetchVariant(this.state.tab, params)
    }, 250)
  }

  _changePage = (page) => {
    this.setState({ page })
    setTimeout(() => {
      const params = { page }
      this._fetchVariant(this.state.tab, params)
    }, 250)
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
    const params = { page: this.state.page }
    if (!modalId) { this._fetchVariant(this.state.tab, params) }
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _deleteSize = () => {
    this.props.deleteSize(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _deleteColour = () => {
    this.props.deleteColour(this.state.detail.id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  render () {
    const { size, colour } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Manage Variant
              {
                this.state.tab === 'tab-size'
                  ? (size.fetching || size.processing) && <div className='badge badge-info ml-2'>{ size.fetching ? 'Loading' : 'Processing' } ...</div>
                  : (colour.fetching || colour.processing) && <div className='badge badge-info ml-2'>{ colour.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            {
              this.state.tab === 'tab-colour'
                ? <button className='btn btn-primary' onClick={() => this._toggleModal('create-colour')}>Create Type</button>
                : <button className='btn btn-primary' onClick={() => this._toggleModal('create-size')}>Create Subtype</button>
            }
          </div>
          <div className='btn-group mb-4' role='group'>
            <button
              className={`btn btn-primary ${(!this.state.tab || this.state.tab === 'tab-colour') && 'active'}`}
              onClick={() => this._changeTab('tab-colour')}
            >
              Type Variant
            </button>
            <button
              className={`btn btn-primary ${(!this.state.tab || this.state.tab === 'tab-size') && 'active'}`}
              onClick={() => this._changeTab('tab-size')}
            >
              Subtype Variant
            </button>
          </div>
        </header>
        <section className='section'>
          {
            this.state.tab === 'tab-size' &&
            <div className='card'>
              {
                !(size.fetching || size.processing) && size.err &&
                <div className='alert alert-danger'>{size.err}</div>
              }
              <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                <thead>
                  <tr>
                    <th className='text-center'>For Category</th>
                    <th className='text-center'>Subtype</th>
                    <th className='text-center'>Edit subtype</th>
                    <th className='text-center'>Delete subtype</th>
                  </tr>
                </thead>
                <tbody>
                  {!size.data.data || !size.data.data.length
                    ? <tr>
                      <td colSpan='6' className='text-center'>No data</td>
                    </tr>
                    : size.data.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{item.category.name}</td>
                        <td className='text-center'>{item.name}</td>
                        <td className='text-center'>
                          <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-size')} >
                            <i className='fa fa-edit' />Edit
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-size')}>
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          }
          {
            this.state.tab === 'tab-colour' &&
            <div className='card'>
              {
                !(colour.fetching || colour.processing) && colour.err &&
                <div className='alert alert-danger'>{colour.err}</div>
              }
              <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                <thead>
                  <tr>
                    <th className='text-center'>Type Name</th>
                    <th className='text-center'>Type Color Code</th>
                    <th className='text-center'>Edit Type</th>
                    <th className='text-center'>Delete Type</th>
                  </tr>
                </thead>
                <tbody>
                  {!colour.data.data || !colour.data.data.length
                    ? <tr>
                      <td colSpan='6' className='text-center'>No data</td>
                    </tr>
                    : colour.data.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{item.name}</td>
                        <td className='text-center'>
                          <div className='btn mr-2' style={{ backgroundColor: item.colour_code }} />{item.colour_code}
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-colour')} >
                            <i className='fa fa-edit' />
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-colour')}>
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          }
        </section>

        {
          this.state.tab === 'tab-size' &&
          <section className='text-center'>
            {(size.data && size.data.total > 100) &&
              <Pagination
                innerClass='pagination'
                itemClass='page-item'
                linkClass='page-link'
                activePage={size.data.page || this.state.page}
                itemsCountPerPage={100}
                totalItemsCount={size.data.total}
                pageRangeDisplayed={5}
                onChange={this._changePage}
              />}
          </section>
        }
        {
          this.state.tab === 'tab-colour' &&
          <section className='text-center'>
            {(colour.data && colour.data.total > 100) &&
              <Pagination
                innerClass='pagination'
                itemClass='page-item'
                linkClass='page-link'
                activePage={colour.data.page || this.state.page}
                itemsCountPerPage={100}
                totalItemsCount={colour.data.total}
                pageRangeDisplayed={5}
                onChange={this._changePage}
              />}
          </section>
        }

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-size'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateSize closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-size'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateSize detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'delete-size'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3>Delete Type</h3>
            </div>
            <div className='text-center'>
              <h6>
                Confirm deletion for "{this.state.detail.name}" type?
              </h6>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteSize()}>Delete</button>
            </div>
          </section>
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-colour'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateColour closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'edit-colour'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateColour detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'delete-colour'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3>Delete Type</h3>
            </div>
            <div className='text-center'>
              <h6>
                Confirm deletion for "<span style={{ color: this.state.detail.colour_code }}>{this.state.detail.name}</span>" type?
              </h6>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteColour()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  size: state.size,
  colour: state.colour
})

const dispatchToProps = (dispatch) => ({
  getSize: (filter) => dispatch(SizeActions.getSizeRequest(filter)),
  getColour: (filter) => dispatch(ColourActions.getColourRequest(filter)),
  deleteSize: (id) => dispatch(SizeActions.deleteSizeRequest(id)),
  deleteColour: (id) => dispatch(ColourActions.deleteColourRequest(id))
})

export default connect(stateToProps, dispatchToProps)(ManageVariant)



// WEBPACK FOOTER //
// ./src/Pages/Ecommerce/ManageVariant.js